// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamEdit_grid-row-2__Puyb6 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.TeamEdit_vm-20__DlrPi {
  margin: 20px 0;
}

.TeamEdit_divider-0__NxzEe {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.TeamEdit_rel__TUawT {
  position: relative;
}

.TeamEdit_flex__u4Y2f {
  display: flex;
}

.TeamEdit_jcc__XDpho {
  justify-content: center !important;
}

.TeamEdit_grid-row-2__Puyb6 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.TeamEdit_vm-20__DlrPi {
  margin: 20px 0;
}

.TeamEdit_divider-0__NxzEe {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.TeamEdit_rel__TUawT {
  position: relative;
}

.TeamEdit_flex__u4Y2f {
  display: flex;
}

.TeamEdit_jcc__XDpho {
  justify-content: center !important;
}

html {
  font-family: "SFProDisplay", sans-serif;
  font-size: 14px;
  color: #000000;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  min-width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  font-family: "SFProDisplay";
  color: #000000;
}

body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

a {
  display: block;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  width: 100%;
}
a:hover {
  cursor: pointer;
}

button,
input,
textarea,
select {
  font-family: inherit;
}

.TeamEdit_display-none__ZyskB {
  display: none;
}

.TeamEdit_container__lv34D {
  padding: 0 204px;
  margin-top: 24px;
}

.TeamEdit_local-container__t2KY8 {
  width: 100%;
  padding: 32px 204px;
}

.TeamEdit_outer-container__Uo6P7 {
  width: 100%;
  padding: 32px 204px;
}

.TeamEdit_full-width__0Gaue {
  width: 100%;
}

.TeamEdit_pagination__e3knK {
  margin-top: 48px;
}

.TeamEdit_long-string__YQ2RS {
  display: inline-block;
  max-width: 200px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.TeamEdit_short-string__FAlQP {
  display: inline-block;
  max-width: 100px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f5faff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #d1d5df;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #d5d5d6;
}

.TeamEdit_details__ubK8w {
  display: flex;
  flex-direction: column;
  position: relative;
}
.TeamEdit_details__header__SZd5r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 204px 48px;
}
.TeamEdit_details__body__q8McV {
  display: flex;
  flex-direction: column;
  padding: 0 204px;
}
.TeamEdit_details__body__q8McV .TeamEdit_row__bQYJT {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.TeamEdit_details__body__q8McV .TeamEdit_row__bQYJT .TeamEdit_detail__Of1SL {
  display: flex;
  flex-direction: column;
  width: 33%;
  padding-right: 30px;
  margin-bottom: 33px;
}
.TeamEdit_details__body__q8McV .TeamEdit_row__bQYJT .TeamEdit_detail_full__Teadw {
  width: 100% !important;
}
.TeamEdit_details__body__q8McV .TeamEdit_row__bQYJT .TeamEdit_detail__content-title__-49C6 {
  margin-bottom: 16px;
}
.TeamEdit_details__divider__yOTi3 {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
  margin: 8px 0 40px;
}

.TeamEdit_divider__Vn9lP {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
  margin: 8px 0 40px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.TeamEdit_grid-row-2__Puyb6 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.TeamEdit_vm-20__DlrPi {
  margin: 20px 0;
}

.TeamEdit_divider-0__NxzEe {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.TeamEdit_rel__TUawT {
  position: relative;
}

.TeamEdit_flex__u4Y2f {
  display: flex;
}

.TeamEdit_jcc__XDpho {
  justify-content: center !important;
}

.TeamEdit_team__E4hpE {
  display: flex;
  flex-direction: column;
}
.TeamEdit_team__header__S7Ooh {
  padding: 0 204px;
  margin: 32px 0;
  font-weight: 600;
  font-size: 32px;
  line-height: 41px;
  color: #000000;
}
.TeamEdit_team__navigation__tqssl {
  padding: 0 204px;
  margin: 20px 0;
}
.TeamEdit_team__filters__SlEJZ {
  padding: 0 204px;
}

.TeamEdit_headblock__mxoGv {
  display: flex;
  justify-content: space-between;
  margin: 60px 0 40px 0;
  padding: 0 204px;
}

.TeamEdit_buttons__UFW3Y {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-left: 50px;
}
.TeamEdit_buttons__elements__wm5dy {
  margin: 0 15px;
  flex-shrink: 0;
}

.TeamEdit_navigation__iAbCh {
  margin: 40px 0px;
}

.TeamEdit_participants_block__yrcIq {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px 20px;
}

.TeamEdit_input_wraper__46Na0 {
  margin-bottom: 20px;
}
.TeamEdit_input_wraper__name__TcfqJ {
  margin-bottom: 20px;
  max-width: 328px;
}
.TeamEdit_input_wraper__description__N097C {
  min-height: 106px;
}
.TeamEdit_input_wraper__description__N097C {
  height: 82px;
}

.TeamEdit_logo_wraper__n\\+FQN {
  display: flex;
  align-items: center;
}
.TeamEdit_logo_wraper__logo__GHVzM {
  vertical-align: middle;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 0 10px;
}
.TeamEdit_logo_wraper__links__gdnjy {
  display: flex;
}
.TeamEdit_logo_wraper__edit__8HhuP {
  margin-left: 24px;
  margin-right: 16px;
  font-family: "SB Sans Display";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  color: #00809C;
}
.TeamEdit_logo_wraper__edit__8HhuP:hover {
  text-decoration: none;
  color: #00809C;
  cursor: pointer;
}
.TeamEdit_logo_wraper__delete__DSBxU {
  font-family: "SB Sans Display";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  color: #EC1B28;
}
.TeamEdit_logo_wraper__delete__DSBxU:hover {
  text-decoration: none;
  color: #EC1B28;
  cursor: pointer;
}
.TeamEdit_logo_wraper__hider_input__GqNzE {
  display: none;
}

.TeamEdit_team_list_wrapper__7V1UQ {
  margin: 24px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 24px;
}

.TeamEdit_divider__Vn9lP {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
  margin: 8px 0 20px;
}

.TeamEdit_error__5qlsj {
  text-align: center;
  color: #ee505a;
}

.TeamEdit_popupLink__yQ-76 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/components/pages/team/TeamEdit/TeamEdit.module.scss","webpack://./src/assets/helpers/colors.scss","webpack://./src/assets/global.scss","webpack://./src/components/pages/team/Team.module.scss","webpack://./src/assets/helpers/standarts.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;ADzBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AC4BF;;ADxBA;EACE,cAAA;AC2BF;;ADvBA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADoCR;;ADtBA;EACE,kBAAA;ACyBF;;ADtBA;EACE,aAAA;ACyBF;;ADtBA;EACE,kCAAA;ACyBF;;AEpDA;EACE,uCAAA;EACA,eAAA;EACA,cDkBS;ADqCX;;AEpDA;;;EAGE,sBAAA;AFuDF;;AEpDA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cDOM;ADgDR;;AEpDA;;;;;;;;;;;;;;EAcE,SAAA;AFuDF;;AEpDA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AFuDF;AErDE;EACE,eAAA;AFuDJ;;AEnDA;;;;EAIE,oBAAA;AFsDF;;AEnDA;EACE,aAAA;AFsDF;;AEnDA;EACE,gBAAA;EACA,gBAAA;AFsDF;;AEnDA;EACE,WAAA;EACA,mBAAA;AFsDF;;AEnDA;EACE,WAAA;EACA,mBAAA;AFsDF;;AEnDA;EACE,WAAA;AFsDF;;AEnDA;EACE,gBAAA;AFsDF;;AEnDA;EACE,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AFsDF;;AEnDA;EACE,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AFsDF;;AElDA,UAAA;AACA;EACE,UAAA;AFqDF;;AElDA,UAAA;AACA;EACE,mBD3GS;ADgKX;;AElDA,WAAA;AACA;EACE,kBAAA;EACA,mBD7GM;ADkKR;;AElDA,oBAAA;AACA;EACE,mBD3GW;ADgKb;;AEjDA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AFoDF;AElDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;AFoDJ;AEjDE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AFmDJ;AEjDI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AFmDN;AEjDM;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AFmDR;AEjDQ;EACE,sBAAA;AFmDV;AE/CU;EACE,mBAAA;AFiDZ;AE1CE;EACE,WAAA;EACA,WAAA;EACA,yBDpKI;ECqKJ,kBAAA;AF4CJ;;AExCA;EACE,WAAA;EACA,WAAA;EACA,yBD5KM;EC6KN,kBAAA;AF2CF;;AExCA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AF2CF;;AExCA,YAAA;AACA;EACE,0BAAA;AF2CF;;ADzOA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AC4OF;;ADxOA;EACE,cAAA;AC2OF;;ADvOA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADoPR;;ADtOA;EACE,kBAAA;ACyOF;;ADtOA;EACE,aAAA;ACyOF;;ADtOA;EACE,kCAAA;ACyOF;;AGpQA;EACE,aAAA;EACA,sBAAA;AHuQF;AGrQE;EACE,gBAAA;EACA,cAAA;ECLF,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cHqBM;ADwPR;AGvQE;EACE,gBAAA;EACF,cAAA;AHyQF;AGtQE;EACE,gBAAA;AHwQJ;;AAtRA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;AAyRD;;AAtRA;EACC,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AAyRD;AAvRC;EACC,cAAA;EACA,cAAA;AAyRF;;AArRA;EACC,gBAAA;AAwRD;;AArRA;EACC,aAAA;EACA,8BAAA;EACA,aAAA;AAwRD;;AArRA;EACC,mBAAA;AAwRD;AAtRC;EACC,mBAAA;EACA,gBAAA;AAwRF;AArRC;EAEC,iBAAA;AAsRF;AAnRC;EACC,YAAA;AAqRF;;AAjRA;EACC,aAAA;EACA,mBAAA;AAoRD;AAlRC;EACC,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAoRF;AAjRC;EACC,aAAA;AAmRF;AAhRC;EACC,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAkRF;AAhRE;EACC,qBAAA;EACA,cAAA;EACA,eAAA;AAkRH;AA9QC;EACC,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAgRF;AA9QE;EACC,qBAAA;EACA,cAAA;EACA,eAAA;AAgRH;AA5QC;EACC,aAAA;AA8QF;;AA1QA;EACC,cAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AA6QD;;AA1QA;EACC,WAAA;EACA,WAAA;EACA,yBC5GO;ED6GP,kBAAA;AA6QD;;AA1QA;EACC,kBAAA;EACA,cChFK;AD6VN;;AA1QA;EACC,WAAA;AA6QD","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import '../../../../assets/helpers/index.scss';\n@import '../../../../assets/global.scss';\n@import '../../team/Team.module.scss';\n\n.headblock {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: 60px 0 40px 0;\n\tpadding: 0 $horizontalPadding;\n}\n\n.buttons {\n\tdisplay: flex;\n\tjustify-content: end;\n\talign-items: center;\n\tmargin-left: 50px;\n\n\t&__elements {\n\t\tmargin: 0 15px;\n\t\tflex-shrink: 0\n\t}\n}\n\n.navigation {\n\tmargin: 40px 0px;\n}\n\n.participants_block {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 5px 20px;\n}\n\n.input_wraper {\n\tmargin-bottom: 20px;\n\n\t&__name {\n\t\tmargin-bottom: 20px;\n\t\tmax-width: 328px;\n\t}\n\n\t&__description {\n\t\t// margin-bottom: 20px;\n\t\tmin-height: 106px;\n\t}\n\n\t&__description {\n\t\theight: 82px;\n\t}\n}\n\n.logo_wraper {\n\tdisplay: flex;\n\talign-items: center;\n\n\t&__logo {\n\t\tvertical-align: middle;\n\t\twidth: 64px;\n\t\theight: 64px;\n\t\tborder-radius: 50%;\n\t\tmargin: 0 0 10px;\n\t}\n\n\t&__links {\n\t\tdisplay: flex;\n\t}\n\n\t&__edit {\n\t\tmargin-left: 24px ;\n\t\tmargin-right: 16px ;\n\t\tfont-family: 'SB Sans Display';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 26px;\n\t\tcolor: #00809C;\n\n\t\t&:hover {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: #00809C;\n\t\t\tcursor: pointer\n\t\t}\n\t}\n\n\t&__delete {\n\t\tfont-family: 'SB Sans Display';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 26px;\n\t\tcolor: #EC1B28;\n\n\t\t&:hover {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: #EC1B28;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t&__hider_input {\n\t\tdisplay: none;\n\t}\n}\n\n.team_list_wrapper {\n\tmargin: 24px 0;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 20px 24px;\n}\n\n.divider {\n\twidth: 100%;\n\theight: 1px;\n\tbackground-color: $gray5;\n\tmargin: 8px 0 20px;\n}\n\n.error {\n\ttext-align: center;\n\tcolor: $danger;\n}\n\n.popupLink {\n\twidth: 100%;\n}\n","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;","@import './helpers/index.scss';\n\nhtml {\n  font-family: 'SFProDisplay', sans-serif;\n  font-size: 14px;\n  color: $headText;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  min-width: 100vw;\n  min-height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n  font-family: 'SFProDisplay';\n  color: $black;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\na {\n  display: block;\n  font-size: 14px;\n  text-align: center;\n  text-decoration: none;\n  width: 100%;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n}\n\n.display-none {\n  display: none;\n}\n\n.container {\n  padding: 0 $horizontalPadding;\n  margin-top: 24px;\n}\n\n.local-container {\n  width: 100%;\n  padding: 32px $horizontalPadding;\n}\n\n.outer-container {\n  width: 100%;\n  padding: 32px $horizontalPadding;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.pagination {\n  margin-top: 48px;\n}\n\n.long-string {\n  display: inline-block;\n  max-width: 200px!important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.short-string {\n  display: inline-block;\n  max-width: 100px!important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n// custom scroll bar\n/* width */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: $scrollBg;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  background: $scroll;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: $scrollHover;\n}\n\n// Details pages\n.details {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 32px $horizontalPadding 48px;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    padding: 0 $horizontalPadding;\n\n    .row {\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n\n      .detail {\n        display: flex;\n        flex-direction: column;\n        width: 33%;\n        padding-right: 30px;\n        margin-bottom: 33px;\n\n        &_full {\n          width: 100%!important;\n        }\n\n        &__content {\n          &-title {\n            margin-bottom: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  &__divider {\n    width: 100%;\n    height: 1px;\n    background-color: $gray5;\n    margin: 8px 0 40px;\n  }\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n  margin: 8px 0 40px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}","@import '../../../assets/helpers/index.scss';\n\n.team {\n  display: flex;\n  flex-direction: column;\n\n  &__header {\n    padding: 0 $horizontalPadding;\n    margin: 32px 0;\n    @include header;\n  }\n\n  &__navigation {\n    padding: 0 $horizontalPadding;\n\t\tmargin: 20px 0;\n  }\n\n  &__filters {\n    padding: 0 $horizontalPadding;\n  }\n}\n","@import './colors.scss';\n\n@mixin header {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 41px;\n  color: $black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-row-2": `TeamEdit_grid-row-2__Puyb6`,
	"vm-20": `TeamEdit_vm-20__DlrPi`,
	"divider-0": `TeamEdit_divider-0__NxzEe`,
	"rel": `TeamEdit_rel__TUawT`,
	"flex": `TeamEdit_flex__u4Y2f`,
	"jcc": `TeamEdit_jcc__XDpho`,
	"display-none": `TeamEdit_display-none__ZyskB`,
	"container": `TeamEdit_container__lv34D`,
	"local-container": `TeamEdit_local-container__t2KY8`,
	"outer-container": `TeamEdit_outer-container__Uo6P7`,
	"full-width": `TeamEdit_full-width__0Gaue`,
	"pagination": `TeamEdit_pagination__e3knK`,
	"long-string": `TeamEdit_long-string__YQ2RS`,
	"short-string": `TeamEdit_short-string__FAlQP`,
	"details": `TeamEdit_details__ubK8w`,
	"details__header": `TeamEdit_details__header__SZd5r`,
	"details__body": `TeamEdit_details__body__q8McV`,
	"row": `TeamEdit_row__bQYJT`,
	"detail": `TeamEdit_detail__Of1SL`,
	"detail_full": `TeamEdit_detail_full__Teadw`,
	"detail__content-title": `TeamEdit_detail__content-title__-49C6`,
	"details__divider": `TeamEdit_details__divider__yOTi3`,
	"divider": `TeamEdit_divider__Vn9lP`,
	"team": `TeamEdit_team__E4hpE`,
	"team__header": `TeamEdit_team__header__S7Ooh`,
	"team__navigation": `TeamEdit_team__navigation__tqssl`,
	"team__filters": `TeamEdit_team__filters__SlEJZ`,
	"headblock": `TeamEdit_headblock__mxoGv`,
	"buttons": `TeamEdit_buttons__UFW3Y`,
	"buttons__elements": `TeamEdit_buttons__elements__wm5dy`,
	"navigation": `TeamEdit_navigation__iAbCh`,
	"participants_block": `TeamEdit_participants_block__yrcIq`,
	"input_wraper": `TeamEdit_input_wraper__46Na0`,
	"input_wraper__name": `TeamEdit_input_wraper__name__TcfqJ`,
	"input_wraper__description": `TeamEdit_input_wraper__description__N097C`,
	"logo_wraper": `TeamEdit_logo_wraper__n+FQN`,
	"logo_wraper__logo": `TeamEdit_logo_wraper__logo__GHVzM`,
	"logo_wraper__links": `TeamEdit_logo_wraper__links__gdnjy`,
	"logo_wraper__edit": `TeamEdit_logo_wraper__edit__8HhuP`,
	"logo_wraper__delete": `TeamEdit_logo_wraper__delete__DSBxU`,
	"logo_wraper__hider_input": `TeamEdit_logo_wraper__hider_input__GqNzE`,
	"team_list_wrapper": `TeamEdit_team_list_wrapper__7V1UQ`,
	"error": `TeamEdit_error__5qlsj`,
	"popupLink": `TeamEdit_popupLink__yQ-76`
};
export default ___CSS_LOADER_EXPORT___;
